<template>
  <section class="oa-progress-panel">
    <div class="oa-progress-panel__heading">
      <div>
        <span>Workflow</span>
        <h2>{{ currentStep.title }}</h2>
      </div>
      <strong>Step {{ activeStep + 1 }} of {{ steps.length }}</strong>
    </div>
    <ol class="oa-progress" aria-label="Odoo payment update progress">
      <li
        v-for="(step, index) in steps"
        :key="step.key"
        :class="{ 'is-current': index === activeStep, 'is-done': index < activeStep }"
        :aria-current="index === activeStep ? 'step' : undefined"
      >
        <span class="oa-progress__number"
          ><i v-if="index < activeStep" class="fa fa-check"></i
          ><template v-else>{{ index + 1 }}</template></span
        >
        <div>
          <strong>{{ step.title }}</strong
          ><span>{{ step.hint }}</span>
        </div>
      </li>
    </ol>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps<{
  steps: Array<{ key: string; title: string; hint: string }>;
  activeStep: number;
}>();
const currentStep = computed(() => props.steps[props.activeStep] || props.steps[0]);
</script>

<style scoped>
.oa-progress-panel {
  margin-bottom: 1.5rem;
  padding: 1.25rem 1.5rem;
  border: 1px solid #e4e7ec;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.04);
}
.oa-progress-panel__heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 1rem;
}
.oa-progress-panel__heading span {
  color: #175cd3;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.oa-progress-panel__heading h2 {
  margin: 0.15rem 0 0;
  font-size: 1.05rem;
}
.oa-progress-panel__heading > strong {
  color: #667085;
  font-size: 0.75rem;
}
.oa-progress {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.65rem;
  margin: 0;
  padding: 0;
  list-style: none;
}
.oa-progress li {
  display: flex;
  gap: 0.65rem;
  align-items: center;
  padding: 0.75rem;
  border: 1px solid #e4e7ec;
  border-radius: 0.65rem;
  background: #f8fafc;
}
.oa-progress__number {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 1.9rem;
  height: 1.9rem;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #667085;
  background: #eaecf0;
  font-weight: 800;
}
.oa-progress li strong,
.oa-progress li div span {
  display: block;
}
.oa-progress li strong {
  color: #344054;
  font-size: 0.8rem;
}
.oa-progress li div span {
  margin-top: 0.15rem;
  color: #667085;
  font-size: 0.68rem;
}
.oa-progress li.is-current {
  border-color: #84adff;
  background: #eff4ff;
}
.oa-progress li.is-current .oa-progress__number {
  color: #fff;
  background: #175cd3;
}
.oa-progress li.is-done {
  border-color: #a6f4c5;
  background: #ecfdf3;
}
.oa-progress li.is-done .oa-progress__number {
  color: #fff;
  background: #039855;
}
@media (max-width: 991px) {
  .oa-progress {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 575px) {
  .oa-progress {
    grid-template-columns: 1fr;
  }
}
</style>
